import { render, staticRenderFns } from "./HeaderColumn.vue?vue&type=template&id=76e8c4e1&scoped=true"
import script from "./HeaderColumn.vue?vue&type=script&lang=ts"
export * from "./HeaderColumn.vue?vue&type=script&lang=ts"
import style0 from "./HeaderColumn.vue?vue&type=style&index=0&id=76e8c4e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8c4e1",
  null
  
)

export default component.exports